<div class="modal-header justify-content-start align-items-center py-0">
  <i class="mdi mdi-alert-circle-outline text-warning f-60 py-2 pr-2"></i>
  <h1 class="fw-500">Deseja consultar as informações abaixo?</h1>
</div>
<div class="modal-body p-4">

  <div class="f-20 text-uppercase">
    <div class="py-1">
      <span class="d-inline-block pr-3">
        <ng-container *ngIf="formValues?.veiculo">
          {{tipoPesquisaVeiculo=='motor' ? 'Motor' : tipoPesquisaVeiculo=='chassi' ? 'Chassi' : 'Placa'}}: {{formValues.veiculo}}<br>
        </ng-container>

        <ng-container *ngIf="formValues.cpf || formValues.cnpj">
          {{formValues.cpf ? 'CPF: ' + formValues.cpf : formValues.cnpj ? 'CNPJ: ' + formValues.cnpj : 'NÃO INFORMADO' }}
        </ng-container>

        <!--Exclusivo para consulta CNH-->
        <ng-container *ngIf="formValues.cnh_cpf">
          {{formValues.cnh_cpf ? 'CPF: ' + formValues.cnh_cpf : 'NÃO INFORMADO' }}
        </ng-container>

      </span>
    </div>
    <div class="py-1" *ngIf="formValues?.documento"><span class="d-inline-block pr-3">Documento:</span> {{formValues.documento}}</div>
    <div class="py-1" *ngIf="formValues?.cnh"><span class="d-inline-block pr-3">CNH:</span> {{formValues.cnh}}</div>
    <div class="py-1" *ngIf="formValues?.crlv"><span class="d-inline-block pr-3">CRLV:</span> {{formValues.crlv}}</div>
    <div class="py-1" *ngIf="formValues?.renavam"><span class="d-inline-block pr-3">Renavam:</span> {{formValues.renavam}}</div>
  </div>

</div>
<div class="modal-footer d-flex">
  <button type="button" class="btn mr-2 btn-secondary" (click)="activeModal.close('cancel')">Cancelar</button>
  <button type="button" ngbAutofocus class="w-100 btn btn-success" (click)="activeModal.close('ok')">Sim, desejo consultar</button>
</div>
